// Centralized backend URL configuration
// Uses dynamic origin detection for maximum deployment flexibility

export const getBackendUrl = () => {
  const origin = window.location.origin;
  
  // Local development - frontend on 3000 needs to talk to backend on 8001
  if (origin.includes('localhost:3000')) {
    return 'http://localhost:8001';
  }
  
  // All other environments (production, preview, staging) - use same origin
  // Kubernetes ingress handles /api routing to backend
  return origin;
};

export const BACKEND_URL = getBackendUrl();

/**
 * Extract a user-friendly error message from an axios error.
 * Guards against non-JSON bodies (e.g. a raw Cloudflare/HTML 502 page that can
 * leak through when an upstream call is slow) by falling back to a clean message.
 */
export const friendlyError = (e, fallback = 'Something went wrong. Please try again.') => {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string' && d.trim() && d.length < 300 && !/<html|<!doctype|cloudflare/i.test(d)) {
    return d;
  }
  return fallback;
};
